import "./SectionHeader.css";
import Dropdown from "react-bootstrap/Dropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faStar,
  faSignal,
  faTimesCircle,
  faCaretDown,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const SectionHeader = ({
  heading,
  icon = null,
  noIconLabel = false,
  dropdownOnly = null,
  more = {
    status: false,
    value: "",
    state: { admin: false },
  },
}) => {
  let dropdownIcon = icon ? icon : faCaretDown;
  let dropdownIconLabel = noIconLabel ? "" : "مرتب سازی";

  let dropdownBodyz;

  if (dropdownOnly) {
    dropdownBodyz = (
      <ButtonGroup
        dropdownIcon={dropdownIcon}
        dropdownIconLabel={dropdownIconLabel}
      />
    );
  } else if (more.status) {
    dropdownBodyz = (
      <HeadingWrapper twoItems={true} heading={heading}>
        {more.state ? (
          <Link
            to={{
              pathname: more.value,
              state: more.state,
            }}
          >
            <span className="more" title="مشاهده ویدئو بیشتر">
              بیشتر
            </span>
          </Link>
        ) : (
          <Link to={more.value}>
            <span className="more" title="مشاهده ویدئو بیشتر">
              بیشتر
            </span>
          </Link>
        )}
      </HeadingWrapper>
    );
  } else {
    dropdownBodyz = (
      <HeadingWrapper heading={heading}>
        {/*<ButtonGroup
          dropdownIcon={dropdownIcon}
          dropdownIconLabel={dropdownIconLabel}
        />*/}
      </HeadingWrapper>
    );
  }

  return <>{dropdownBodyz}</>;
};

function ButtonGroup({ dropdownIcon, dropdownIconLabel }) {
  return (
    <>
      <div className="btn-group float-right right-action">
        <Dropdown>
          <Dropdown.Toggle
            as="a"
            id=""
            className="right-action-link text-gray no-after"
          >
            {dropdownIconLabel}{" "}
            <span>
              <FontAwesomeIcon icon={dropdownIcon} />
            </span>
          </Dropdown.Toggle>

          <Dropdown.Menu style={{ textAlign: "right" }}>
            <Dropdown.Item href="#">
              <FontAwesomeIcon icon={faStar} fixedWidth />
              &nbsp;پربازدیدترین
            </Dropdown.Item>
            <Dropdown.Item href="#">
              <FontAwesomeIcon icon={faSignal} fixedWidth />
              &nbsp;مشاهده شده
            </Dropdown.Item>
            <Dropdown.Item href="#">
              <FontAwesomeIcon icon={faTimesCircle} fixedWidth />
              &nbsp;بستن
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </>
  );
}

function HeadingWrapper({ children, heading, twoItems = false }) {
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: twoItems ? "row-reverse" : "",
          justifyContent: "space-between",
        }}
        className="main-title"
      >
        {children ? children : ""}
        <h6>{heading}</h6>
      </div>
    </>
  );
}

export default SectionHeader;
export { HeadingWrapper };
